module.exports = __webpack_public_path__ + "static/media/home-image.bdc5ab4d.png";